import { MENU_LABELS, MENU_REGISTRY, type MenuItem, type MenuKey } from "./menu-registry";
import type { SrIconName } from "@/components/ui/SrIcon";

export interface PaletteNavItem {
  id: string;
  key: MenuKey;
  label: string;
  description: string;
  path: string;
  icon: SrIconName;
  searchText: string;
}

export interface MenuAccessRow {
  role: string;
  menu_key: string;
  can_access: boolean;
}

/**
 * Samme canAccess-regel som App.tsx: fail-OPEN mens permissions laster,
 * fail-CLOSED ved feil/manglende data, ellers role_menu_permissions.
 */
export function canAccessMenuKey(
  permissions: MenuAccessRow[] | undefined,
  role: string | undefined,
  key: string,
  opts?: { loading?: boolean; error?: boolean },
): boolean {
  if (!role) return false;
  if (opts?.loading) return true;
  if (opts?.error || !permissions) return false;
  return (
    permissions.find((p) => p.role === role && p.menu_key === key)?.can_access ??
    false
  );
}

/** Sideliste for ⌘K, avledet fra MENU_REGISTRY (ingen egen hardkodet liste). */
export function paletteNavItems(
  canAccess: (key: MenuKey) => boolean,
): PaletteNavItem[] {
  const items: PaletteNavItem[] = [];
  for (const m of MENU_REGISTRY as readonly MenuItem[]) {
    if (!m.nav) continue;
    if (!canAccess(m.key)) continue;
    const parentLabel = m.parent ? MENU_LABELS[m.parent] : undefined;
    const label = parentLabel ? `${parentLabel} / ${m.label}` : m.label;
    const description =
      m.key === "mine-oppgaver"
        ? "Registrer timer"
        : parentLabel
          ? parentLabel
          : `Gå til ${m.label}`;
    items.push({
      id: m.key,
      key: m.key,
      label,
      description,
      path: m.nav.path,
      icon: m.nav.icon,
      searchText: `${label} ${description} ${m.key} ${m.nav.path}`,
    });
  }
  return items;
}

export function newOfferPaletteHref(sizeCode?: string): string {
  if (!sizeCode) return "/tilbud?nytt=";
  return `/tilbud?nytt=${encodeURIComponent(sizeCode)}`;
}
